//--Ruta backend corriendo en servidor
export const global = {
	url: 'https://darkviolet-alpaca-715713.hostingersite.com/api/'
}

//--Ruta backend corriendo en caja
export const globaltk = {
	url: 'http://localhost:5000/api/'
}

//--Ruta backend bioadmin corriendo en el servidor
export const globalb = {
	url: 'http://localhost:6000/api/'
}

export const globaltkp = {
	url: 'http://localhost/ticket/'
}

export const globalES = {
	url: 'http://192.168.1.100:8080/ticket/'
}

/**
 * url: 'http://localhost:5000/api/' 
 * 'http://192.168.1.100:5000/api/'
 * 192.168.1.100/app/ticket/
    'https://darkviolet-alpaca-715713.hostingersite.com/api/' 
 **/ 